<template>

</template>

<script>
import LpTitle from '../partials/LpTitle'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import {COLLECTION_ICONS} from '@/utvStore/components/recommend/lp/commons'
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import ArrowIcon from '@/utvStore/components/common/icon/ArrowIcon'

export default {
  name: 'BlockMenu',
  components: {
    LpTitle,
    swiper,
    swiperSlide,
    LpBaseButton,
    ArrowIcon,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    menuList: {
      type: Array,
      default(){
        return []
      }
    },
    tabList: {
      type: Array,
      default(){
        return []
      }
    },
    subscrEnable: {
      type: Boolean,
      default: false,
    },
    menuId: {
      type: Number,
      default: 0,
    },
    page: String,
    gaEventCateg: {
      type: String,
      default: '',
    },
    noDeco: {
      type: Boolean,
      default: true,
    },
    noSwipe: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listEnable: true,
      lock: false,
      selectedTab: 0,
      selectedCache: 0,
      menuData: {},
      swiperOption: {
        slidesPerView: 1.119,
        spaceBetween: 8,
        centeredSlides: true,
        autoplay: { delay: 5000 },
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      }
    }
  },
  computed:{
    gaEventCategMod(){
      if(this.gaEventCateg.length === 0){
        return `LP${this.lpId}-paid-content-button`
      }else{
        return this.gaEventCateg
      }
    },
    styles(){
      const baseCol = !!this.targetInfo.tabedMenu ? this.targetInfo.tabedMenu.color.baseColor : this.colorScheme.gradStart
      const itemFont = !!this.targetInfo.tabedMenu ? this.targetInfo.tabedMenu.color.itemFont : this.colorScheme.gradStart
      const frameCol = !!this.targetInfo.tabedMenu ? this.targetInfo.tabedMenu.color.frameColor : '#142254'
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--tm-base-col': baseCol,
        '--tm-item-font': itemFont,
        '--tm-frame-col': frameCol,
      }
    },
    collectionIconList(){
      return COLLECTION_ICONS
    },
    tabListMod(){
      if(this.tabList.length > 0){
        let num = 0
        const arr = [...this.tabList]
        num = 3 - this.tabList.length % 3
        for(let i = 0; i < num; i++){
          arr.push({label: '', blank:true})
        }
        return arr
      }else{
        return []
      }
    },
    selectedList(){
      if(this.tabList.length > 0){
        return this.tabList[this.selectedTab].id_list.map((menuId, idx) => {
          return this.menuList.find(tgt => tgt.url_id === menuId && +tgt.open_flg > 0)
        })
      }else {
        return []
      }
    },
  },
  methods: {
    clicked (item) {
      if(!this.lock) {
        window.gtag('event', 'click', {
          'event_category': this.gaEventCategMod,
          'event_label': item.url_id,
        })
        location.href = this.$handoverParams(item.url)
      }
    },
    onTabListItemClick(val, isLwr){
      if(!this.lock) {
        const pageLabel = !!this.page && this.page.length > 0 ? this.page : ''
        const pos = isLwr ? 'text' : 'button'
        window.gtag('event', 'click', {
          'event_category': `LP${this.lpId}${pageLabel}-category-${pos}-${this.tabList[val].identify}`,
        })
        this.lock = true
        this.listEnable = false
        this.selectedCache = val
      }
    },
    onAfterLeave(){
      this.selectedTab = this.selectedCache
      this.listEnable = true
    },
    onAfterEnter(){
      this.lock = false
    },
    onListItemClick(val){
      if(!this.lock) {
        const dt = this.selectedList[val]
        const pageLabel = !!this.page && this.page.length > 0 ? this.page : ''
        window.gtag('event', 'click', {
          'event_category': `LP${this.lpId}${pageLabel}-paid-content-list`,
          'event_label': dt.url_id,
        })
        location.href = this.$handoverParams(dt.url)
      }
    },
  },
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_tm_base_col: var(--tm-base-col);
$l_col_tm_item_font: var(--tm-item-font);
$l_col_tm_frame_col: var(--tm-frame-col);

.block-menu-base {
  background: #F3FEFF;
  padding: 46px 0 38px;
  position: relative;
  &__deco {
    position: absolute;
    top: -45px;
    right: 0;
    width: 17.6%;
    max-width: 80px;
    z-index: 2;
  }
  .content-wrap {
    overflow: hidden;
  }
  .swiper-container {
    overflow: visible;
  }
  &__swiper {
    position: relative;
    margin-top: 100px;
    &.no-swipe {
      margin-top: 72px;
      .swiper-button-prev,
      .swiper-button-next {
        display: none;
      }
    }
    .fixed-panel {
      padding: 0 20px;
      margin-bottom: 8px;
      @include mq('w580'){
        padding: 0 40px;
        margin-bottom: 16px;
      }
      &:last-child {
        margin-bottom: 0;
      }
      .swiper-slide {
        padding: 114px 20px 24px;
        .block-menu-base__category {
          top: 24px;
        }
      }

    }
  }
  .swiper-slide {
    padding: 71px 20px 24px;
    background: #FFFFFF;
    border: 1px solid $l_col_keycolor;
    border-radius: 10px;
    height: auto;
    .box {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-items: flex-end;
    }
  }
  &__category {
    position: absolute;
    width: 68px;
    top: -34px;
    left: 0;
    right: 0;
    margin: auto;
  }
  &__title {
    flex: 1 1 100%;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 24px;
    line-height: 26px;
    text-align: center;
    color: $l_col_keycolor;
    margin: 0 auto 37px;
  }
  &__description {
    flex: 1 1 100%;
    font-size: 14px;
    line-height: 21px;
    text-align: justify;
    padding: 0 0 16px;
    margin: 0 0 16px;
    border-bottom: 1px solid #DADADA;
  }
  &__price {
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    text-align: right;
    color: #FF7497;
    margin: 0 0 24px;
  }
  .baseButton {
    max-width: 270px;
    margin: auto;
  }
  .swiper-pagination {
    position: static;
    transition: 0.3s;
    line-height: 1;
    margin: 12px 0 0;
  }
  /deep/ .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    margin: 0 8px;
    background: #DADADA;
    opacity: 1;
  }
  /deep/ .swiper-pagination-bullet-active {
    background: $l_col_keycolor;
  }
  .swiper-button-prev,
  .swiper-button-next {
    background: $l_col_second;
    opacity: 0.75;
    width: auto;
    height: auto;
    transform: translate(0, calc(-50% - 9px));
    margin: 0;
    padding: 11px;
    font-size: 0;
    border-radius: 100px;
    transition: 0.3s;
    display: none;
    &:hover {
      opacity: 1;
    }
    @include mq('w768') {
      display: block;
    }
  }
  .swiper-button-prev { left: 5px;
    img { transform: rotate(-90deg); }
  }
  .swiper-button-next { right: 5px;
    img { transform: rotate(90deg); }
  }
  .swiper-button-prev.swiper-button-disabled,
  .swiper-button-next.swiper-button-disabled {
    opacity: 0;
  }
  /*
  &--result {
    background: #fff;
    padding-top: 0;
    .block-menu-base__swiper {
      margin-top: 34px;
    }
  }
   */
}


.tabed-menus-base {
  padding: 0 20px;
  .tab-btns-upp {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 14px;
    .tab-btn {
      width: 32%;
      height: 40px;
      display: inline-flex;
      font-size: 12px;
      font-weight: bold;
      margin-bottom: 10px;
      color: $l_col_tm_base_col;
      border: 1px solid $l_col_tm_base_col;
      cursor: pointer;
      user-select: none;
      background: white;
      border-radius: 40px;
      padding: 3px 8px;
      line-height: 1;
      justify-content: center;
      align-items: center;
      &.active {
        background: $l_col_tm_base_col;
        color: white;
        cursor: default;
        pointer-events: none;
      }
      &.blank {
        visibility: hidden;
        cursor: default;
        pointer-events: none;
      }
    }
  }

  .selected-list {
    $col_list_base: $l_col_tm_frame_col;
    border: 1px solid $col_list_base;
    padding: 8px 20px;
    border-radius: 10px;
    background: white;
    margin-bottom: 16px;
    .list-item {
      color: $l_col_tm_item_font;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border-bottom: 1px solid #dadada;
      padding: 16px 38px 16px 0;
      min-height: 100px;
      cursor: pointer;
      user-select: none;
      &:last-child {
        border: none;
      }
      .item-title {
        display: inline-block;
        font-size: 14px;
        font-weight: bold;
        line-height: 20px;
      }
      .item-price {
        color: #ff7497;
        display: inline-block;
        font-size: 12px;
        font-weight: bold;
        .encourage-subscr {
          color: #6CD7D0;
        }
      }
      .item-arrow {
        width: 28px;
        height: 28px;
        border-radius: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-left: 2px;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        background: $l_col_tm_base_col;
      }
    }

  }

  .tab-btns-lwr {
    .tab-btn {
      font-size: 12px;
      line-height: 1;
      display: inline-block;
      margin-right: 12px;
      cursor: pointer;
      text-decoration: underline;
      color: $l_col_tm_base_col;
      user-select: none;

      &.active {
        text-decoration: none;
        cursor: default;
        pointer-events: none;
      }
    }
  }
}

.tablist-enter-active,
.tablist-leave-active {
  transition: all 200ms ease-out 0s;
}

.tablist-enter, .tablist-leave-to {
  opacity: 0;
}

.tablist-enter-to, .tablist-leave {
  opacity: 1;
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/blocks/BlockMenus.vue